export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            display: { base: 'flex', lg: 'block' },
            flexDirection: { base: 'column' },
            textAlign: { lg: 'center' },
            paddingTop: { lg: 1 },
            paddingBottom: { lg: 1 }
        },
        hideOnDesktop: {
            display: { base: 'flex', lg: 'none' }
        },
        hideOnMobile: {
            display: { base: 'none', lg: 'block' }
        },
        titleContainer: {
            justifyContent: { base: 'space-between' },
            paddingTop: { base: 3, lg: 0 },
            paddingBottom: { base: 3, lg: 0 },
        },
        title: {
            justifyContent: { base: 'flex-start' },
            fontSize: { base: 'md' },
            fontWeight: { base: 'bold' },
            lineHeight: { base: '20px' },
            letterSpacing: { base: '0' },
            textTransform: { base: 'uppercase' },
            textAlign: { base: 'left', lg: 'center' },
            mb: { lg: 2 },
            textDecoration: { base: 'none' },
            _hover: {
                textDecoration: { base: 'none' }
            }
        },
        description: {
            display: { base: 'none', lg: 'block' },
            fontSize: { lg: 'xs' },
            fontWeight: { lg: 'medium' },
            lineHeight: { lg: '100%' },
            letterSpacing: { lg: '0' },
            mb: { lg: 2 }
        },
        linkContainer: {
            display: { base: 'none', lg: 'block' },
            lineHeight: { lg: '15px' }
        },
        link: {
            display: { lg: 'inline-block' },
            fontSize: { base: 'xs' },
            fontWeight: { lg: 'medium' },
            lineHeight: { lg: '15px' },
            letterSpacing: { lg: '0' },
            textDecoration: { base: 'none', lg: 'underline' }
        },
        dividerStyling: {
            borderColor: { base: 'grey.400', lg: props?.SplitBarColor || 'black' },
            borderWidth: { base: '1px' },
            marginLeft: { lg: 1 },
            marginRight: { lg: 1 }
        },
        arrow: {
            width: { base: '12px' },
            height: { base: 'auto' },
            transform: { base: 'rotate(270deg)' }
        }
    })
}
